import React from 'react';
import { CORPORATE_SITE, trimAll } from '../../utils';
import { FooterSocialIcons, SPECIALIZED, ABOUT_MILAN_ITEMS } from '.';

const FooterList = ({ list }) => (
  <ul className='list-wrapper d-flex flex-column flex-wrap'>
    {/* {list.map((item, i) => <li key={i}><a href={`${CORPORATE_SITE}/${item.path}`} target="_blank">{item.text}</a></li>)} */}
    {list.map((item, i) =>
      item.corp === true ? (
        <li key={i}>
          <a href={`${CORPORATE_SITE}/${item.path}`} target='_blank'>
            {item.text}
          </a>
        </li>
      ) : (
        <li key={i}>
          <a href={`/${item.path}`}>{item.text}</a>
        </li>
      )
    )}
  </ul>
);

const FooterListAbout = ({ list }) => (
  <ul className='list-wrapper d-flex flex-column flex-wrap'>
    {/* {list.map((item, i) => <li key={i}><Link to={`/${item.path}`}>{item.text}</Link></li>)} */}
    {list.map((item, i) => (
      <li key={i}>
        <a href={`${CORPORATE_SITE}/${item.path}`} target='_blank'>
          {item.text}
        </a>
      </li>
    ))}
    <li>
      <a href='javascript:void(0)' className='ot-sdk-show-settings'>
        Your Privacy Rights
      </a>
    </li>
  </ul>
);

export function FooterTop({ milanStores, currentMetro }) {
  return (
    <section id='footer-top' className='w-100 pt-5'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-4 mb-4'>
            <h4 className='milan-text-secondary'>
              Milan Laser Hair Removal Locations
            </h4>
            <ol
              id='states-list'
              className='list-wrapper d-flex flex-column flex-wrap'
            >
              {milanStores.length !== 0 &&
                milanStores.map((state, s) => (
                  <li key={s}>
                    <a
                      href={`${CORPORATE_SITE}/locations/${trimAll(
                        state.name
                      ).toLowerCase()}/`}
                    >
                      {state.name}
                    </a>
                  </li>
                ))}
            </ol>
          </div>
          <div className='col-md-6 offset-lg-1 col-lg-4 mb-4'>
            <h4 className='milan-text-secondary'>Laser Hair Removal Topics</h4>
            <FooterList list={SPECIALIZED} />
          </div>
          <div className='col-md-6 col-lg-3 mb-4'>
            <h4 className='milan-text-secondary'>About Milan</h4>
            {/* this is the current one */}
            {/* <FooterList list={ABOUT_MILAN_ITEMS} /> */}
            {/* {currentMetro.metroPath === 'flagstaff' ? <FooterListAbout list={ABOUT_MILAN_ITEMS} /> : <FooterList list={ABOUT_MILAN_ITEMS} />} */}
            <FooterListAbout list={ABOUT_MILAN_ITEMS} />
            <h4 className='milan-text-secondary'>Follow Us</h4>
            <FooterSocialIcons currentMetro={currentMetro} />
          </div>
        </div>
      </div>
    </section>
  );
}
export default FooterTop;
